import { Environment, ShopBundle } from '../types';

import { Config, DefaultConfig } from './Config';

import { prodConfig, defaultConfig, devConfig, commonConfig } from './';

/*
 *  The default configuration is the one common to all environments. In particular, it holds enough information to initialize a SentryService.
 */
export function getDefaultConfig(): DefaultConfig {
  return {
    appVersion: process.env.REACT_APP_VERSION ?? 'unknown',
    ...defaultConfig,
  };
}

const isBrowser = () => typeof window !== 'undefined';

export const selectConfig = (env: Environment) => {
  if (isBrowser() && !window.Payment) window.Payment = {};

  return (shopBundle: ShopBundle = 'zooplus') => {
    const envConfig = env === 'prod' ? prodConfig : devConfig;

    const mergedShopConfig = {
      ...commonConfig[shopBundle],
      ...envConfig.shopCommon,
      ...envConfig[shopBundle],
    };

    const config: Config = { env, ...getDefaultConfig(), ...mergedShopConfig };
    if (isBrowser()) window.Payment.__APP_RUNNING_CONFIG__ = config;

    return config;
  };
};
